// Define Firebase config
export const PRODConfig = {
    apiKey: "AIzaSyC4nHVHnJekQraTN_QdehfKg81kcGHR5xI",
    authDomain: "neophyten-gis.firebaseapp.com",
    databaseURL: "https://neophyten-gis.firebaseio.com",
    projectId: "neophyten-gis",
    storageBucket: "neophyten-gis.appspot.com",
    messagingSenderId: "818896867129",
    appId: "1:818896867129:web:84d8ae36a6a5ccc516a2e8",
    measurementId: "G-5Y9KSL6VEF"
};

export const DEVConfig = {
    apiKey: "AIzaSyAZjbMaWjv5ocWHY1BNfNaberd4KONserw",
    authDomain: "neophyten-dev.firebaseapp.com",
    databaseURL: "https://neophyten-dev-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "neophyten-dev",
    storageBucket: "neophyten-dev.firebasestorage.app",
    messagingSenderId: "628937318427",
    appId: "1:628937318427:web:a32a081c38bc6668d798be"
};

export const PRODBaseURL = "https://neos.crellutions.at/";
export const DEVBaseURL = "https://neophyten.dev.crellutions.at/";
